import {useLocation} from "react-router-dom";

/** Allows for manipulation of search parameters in url */
export const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
